import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../../../../common_comp/Layout/Layout";

const Privacy = () => {
  return (
   <Layout>
     <Container className="my-5   mx-auto ">
      <Row className="px-3    ">
        <h1 className="text-center fw-bold mb-4"> Privacy Policy </h1>
        <p>
          This privacy policy sets out how Green Publication ("we" and "us")
          uses and protects any information that you ("user") give when you use
          this website. Green Publication is committed to ensuring that your
          privacy is protected. If you have any questions regarding this Privacy
          Policy please contact us. For more efficient and expedient handling of
          your request, please include your name, contact information, and if
          possible account number(s).
        </p>
        <p>Registration and What We Collect</p>
        <p>
          When you create an account on Green Publication website, we may
          collect the following information:
        </p>
        <ul>
          <li className="mx-3">
            First name, Last name, academic/job title, and
            Organization/Institution.
          </li>
          <li className="mx-3">
            Contact information in the form of email address, postal address,
            country of residence.
          </li>
          <li className="mx-3" >
            {" "}
            Other information regarding your scientific field of interest,
            education and work experience.
          </li>
          <li className="mx-3"> Password</li>
        </ul>

        <strong className="my-2">E-mail Policy : </strong>
        <p>
          It is the policy of Green Publication Publishing to send our members
          emails throughout the publishing process and another email they elect
          to receive, in addition to customary business communications (payment
          confirmations, etc.). Further, it is our policy to immediately remove
          any member from any mailing list upon the member's request. In
          addition, Green Publication will send newsletters and other
          communications to members. Newsletters will contain clear and obvious
          instructions for how the member can remove himself or herself from
          that mailing list.We do use email as a means of receiving feedback
          from our members, and we encourage you to email us with your questions
          or comments.
        </p>

        <strong className="my-2">Our Commitment to Data Security :</strong>
        <p>
          We endeavour to keep your personal information confidential and
          protected against unauthorised access, loss, misuse or alteration
          through the use of industry-standard encryption technologies. Your
          personal information is stored on servers that are behind a firewall
          and physically located within a secured data centre. However, no
          information transferred over the Internet is completely secure and,
          therefore, Green Publication cannot guarantee with 100% certainty the
          total security of information transmitted to it.
        </p>

        <strong className="my-2">Your rights:</strong>

        <ol>
          <li className="mx-3">
        
            You can choose what information you make available to other
            registered and unregistered users.
          </li>
          <li className="mx-3">
            If you no longer desire our services you can deactivate your account
            by emailing us at any time.
          </li>
        </ol>
      </Row>
    </Container>
   </Layout>
  );
};

export default Privacy;
